
export class TenantSummaryModel {
  id: string;
  name: string;
  code: string;
  federatedDomains: string[];
  isAMT: boolean|null;
  isActive: boolean;
}
